let Recaptcha = {

    run: () => {

        document.querySelectorAll('.g-recaptcha').forEach(function (elm) {
            elm.addEventListener('click',function (e) {
                e.preventDefault();

                const btn = this;
                const key = this.dataset.recaptcha;

                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute(key, {action: 'submit'}).then(function (token) {

                        let hidden =  document.createElement("input");
                        hidden.name = 'token';
                        hidden.type = 'hidden';
                        hidden.value = token;

                        btn.parentNode.append(hidden);
                        btn.parentNode.submit();

                    });
                });

            })
        });

    }

}

export default Recaptcha;
